/*
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 15:50:01
 * @FilePath: \saas-perform-web\src\api\account\accountApi.js
 */
import {httpPost,httpGet,baseUrl} from "../axiosFun.js"


export function searchAccountInfoApi(data) {
	return httpGet(baseUrl + "/account/accountInfo",data)
}


// WEBPACK FOOTER //
// ./src/api/account/accountApi.js